// extracted by mini-css-extract-plugin
module.exports = {"dividerCustom":"style_dividerCustom__39KYO"};